import { render, staticRenderFns } from "./KitsCard.vue?vue&type=template&id=34d28332&"
import script from "./KitsCard.vue?vue&type=script&lang=js&"
export * from "./KitsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports